import React, { createContext, useContext, useCallback } from "react";
import { demoNotice } from "@/data/site";

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  // Demo site: booking is disabled — show the portfolio notice instead of scheduling.
  const openBooking = useCallback(() => {
    window.alert(demoNotice);
  }, []);

  return (
    <BookingContext.Provider value={{ openBooking }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
